import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import '@adyen/adyen-web/dist/adyen.css';

import * as ShopSelectors from 'selectors/ShopSelectors';
import { AdditionalPaymentAction } from 'common/types';
import AdyenCardElement from './AdyenCardElement';
import PaymentProcessDialog from 'common/components/payment/PaymentProcessDialog';
import { useTranslation } from 'services/localization';
import Spinner from 'common/components/Spinner';
import { Box, Typography } from '@mui/material';
import { AdditionalDetailsUpdate } from 'common/components/payment/PaymentMethodSelector';
import { useAdyen } from 'common/hooks/useAdyen';

interface Props {
	onAdyenAdditionalDetails: (state: AdditionalDetailsUpdate) => void;
	paymentLoading: boolean;
	paymentInProgress: boolean;
	additionalPaymentAction: AdditionalPaymentAction;
	paymentError: string | null;
}

const PaymentInfo = ({
	additionalPaymentAction,
	paymentInProgress,
	paymentLoading,
	paymentError,
	onAdyenAdditionalDetails,
}: Props) => {
	const { adyenCheckout } = useAdyen();
	const adyenPaymentMethods = useSelector(ShopSelectors.adyenPaymentMethods);
	const paymentMethodsLoading = adyenPaymentMethods.loading;
	const { t } = useTranslation();
	const paymentMethodError = !!adyenPaymentMethods.error;

	// To fix issues with stale state
	const handleAdyenAdditionalDetailsUpdate = useRef<typeof onAdyenAdditionalDetails>(
		() => undefined,
	);

	useEffect(() => {
		handleAdyenAdditionalDetailsUpdate.current = onAdyenAdditionalDetails;
	});

	return (
		<>
			{paymentMethodsLoading ? (
				<Spinner relative margin={80} />
			) : paymentMethodError ? (
				<Box py={6}>
					<Typography color="textSecondary">{t('common:errors.error')}</Typography>
				</Box>
			) : !adyenCheckout ? null : (
				<AdyenCardElement adyenCheckout={adyenCheckout} paymentError={paymentError} t={t} />
			)}
			<PaymentProcessDialog
				paymentInProgress={paymentInProgress}
				paymentLoading={paymentInProgress && paymentLoading}
				additionalPaymentAction={additionalPaymentAction}
				t={t}
				paymentError={paymentInProgress && paymentError ? paymentError : undefined}
				useZeroAuthTexts={true}
				onAdditionalPaymentDetailsChange={(state) =>
					handleAdyenAdditionalDetailsUpdate.current(state)
				}
			/>
		</>
	);
};

export default PaymentInfo;
